import styled, { css } from 'styled-components';
import { INPUTS_WRAPPER_VERTICAL_SPACING, mediaMap } from '@belong/themes';
import Content from '../../forms/Content';

const InputsWrapper = styled.div`
  > * + * {
    ${mediaMap(
      INPUTS_WRAPPER_VERTICAL_SPACING,
      (spacing: string) => css`
        margin-top: ${spacing};
      `
    )}
  }

  > * + ${Content} {
    margin-top: 3.2rem;
  }
`;

export default InputsWrapper;
